<template>
  <div class='cves-score-table-cell'>
    <span class="amount" @click='toggleCVEsListPopup(item)' v-if='versionExist'>{{ cvesAmount }}</span>
    <span v-else class='material-icons-outlined'>
        remove
    </span>
  </div>
</template>

<script>
export default {
  name: 'TechnologiesCvesAmountTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      cvesListPopup: false,
    };
  },
  methods: {
    toggleCVEsListPopup(tech) {
      this.$emit('toggleCVEsListPopup', tech);
    },
  },
  computed: {
    versionExist() {
      return this.item.versions.some(version => version !== 'N/A');
    },
    cvesAmount() {
      let totalAmount = 0;
      if (this.item[this.column.field]) {
        const cvesVersionsKeys = Object.keys(this.item[this.column.field]);
        for (let i = 0; i < cvesVersionsKeys.length; i += 1) {
          const version = cvesVersionsKeys[i];
          const cves = this.item[this.column.field][version];
          totalAmount += cves.length;
        }
      }
      return totalAmount;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.cves-score-table-cell {
  width: 100%;
  display: flex;
  justify-content: center;

  .amount {
    z-index: 3;
    color: var(--text-primary);
    font-family: $font-family-semibold;
    font-size: $font-size-base;
    letter-spacing: 0;
    line-height: rem(17);
    font-weight: 600;

    &:hover {
      color: var(--brand-primary);
      text-decoration: var(--brand-primary) underline;
      cursor: pointer;
    }
  }

  .material-icons-outlined {
    color: var(--text-muted);
  }
}
</style>
